// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/rsuite.css
// module id = 235
// module chunks = 0